import { memo } from 'react';
import { Box, Flex, Link } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

import LogoSection from 'pages/ModalOverViewPageHeaderRevamp/components/LogoSection';
import UserActions from 'pages/ModalOverViewPageHeaderRevamp/components/UserActions';
import { HEADER_CONFIG } from 'pages/ModalOverViewPageHeaderRevamp/constants';
import { UserModalNew } from 'pages/UserManagement/ProfileNewUIRevamp';
import { accent, radius } from 'styles/revampTokens';

/**
 * The model bar. Tasks sits beside the logo, where the model name sits on a
 * model page. One label centred on its own reads as a leftover tab.
 * The row is the same 30px as the account button, inside the model header's height.
 */
const TasksAppHeader = () => (
  <Box>
    <Flex
      w='100%'
      h={HEADER_CONFIG.HEIGHT}
      px={3}
      bg={HEADER_CONFIG.BG_COLOR}
      borderBottom='1px solid #D1D6DD'
      boxSizing='border-box'
      align='center'
      justify='space-between'
      gap={4}
    >
      <Flex align='center' gap={4} minW={0}>
        <LogoSection globalHeader />
        <Link
          as={RouterLink}
          to='/tasks'
          display='inline-flex'
          alignItems='center'
          h='30px'
          px='16px'
          borderRadius={radius.control}
          bg={accent.solid}
          color='white'
          fontSize='12px'
          fontWeight={500}
          lineHeight='1'
          flexShrink={0}
          _hover={{ bg: accent.hover, color: 'white', textDecoration: 'none' }}
        >
          Tasks
        </Link>
      </Flex>
      <Flex align='center' flexShrink={0}>
        <UserActions globalHeader />
      </Flex>
    </Flex>
    <UserModalNew />
  </Box>
);

export default memo(TasksAppHeader);
